<div class="visuals_selected_header">
    <span>Visuals selected</span>
</div>
<div class="visuals_selected_body">
    <ng-container>
        <div class="widget_selected_div widget_header_row">
            <div class="widget_name widget_header_name">
                Widget Name
            </div>
            <div class="widget_visualization widget_header_viz">
                Visualization
            </div>
            <ng-container>
                <div class="widget_delete widget_header_actions"> </div>
            </ng-container>


        </div>
    </ng-container>
    <div class="scroll_body" [style]="'max-height:'+maxheightofbody" *ngIf="show">
        <div class="widget_selected_div body" *ngFor="let widget of widgetList" cdkDropList
            [cdkDropListData]="widgetList" cdkDropListSortingDisabled (cdkDropListDropped)="drop($event,widget)">
            <div class="widget_name" [ngClass]="{'active':widget.active,'dragDisabled':widget.active, 'widgetColor1': widget.isSoftDelete, 'widgetColor2': !widget.isSoftDelete}" cdkDrag
                [cdkDragDisabled]="disabledrag" title={{widget.widgetName}}>
                <img *cdkDragPreview [src]="widget.image" [alt]="widget.widgetName">
                <span>{{widget.widgetName}}</span>
            </div>
            <div class="widget_visualization" [ngClass]="{'active':widget.active}" title={{widget.visualization}} [ngClass]="{'widgetColor1':widget.isSoftDelete, 'widgetColor2':!widget.isSoftDelete}">
                <span>{{widget.visualization}}</span>
            </div>
            <div class="widget_delete">
                <ng-container *ngIf="deleteFlag==false">
                    <div class="widget_edit edit_icon" *ngIf="!widget.active" (click)="edit(widget)"></div>
                    <div class="widget_edit duplicate_icon" *ngIf="!widget.active" (click)="duplicate(widget)"></div>

                    <div class="widget_delete trash_icon" *ngIf="!widget.active" (click)="delete(widget)"></div>
                    <div class="widget_delete checked_icon" *ngIf="widget.active"></div>
                </ng-container>
                <ng-container *ngIf="!deleteFlag==false">
                    <!-- <div class="widget_delete trash_icon" *ngIf="!widget.active" (click)="delete(widget)"></div> -->
                    <div class="widget_delete checked_icon" *ngIf="widget.active"></div>
                </ng-container>
            </div>


        </div>
    </div>
    <!-- delete confirmation popup -->
    <div *ngIf="showDeletePopup">
        <div class="overlay"></div>
        <app-delete-popup [message]="'Note: Preview Screen will get reset'" [flag]="true" (dataEvent)="receivedDeleteConfirmation($event)"></app-delete-popup>
    </div>

    <app-shared-popup-snapshot *ngIf="showErrorPopUp" [showErrorPopUp]="showErrorPopUp"
  [errorheaderTitle]="errorheaderTitle" [popUpMessage]="popUpMessage"
  (closeErrorPopUp)="onCloseIconClick($event)"></app-shared-popup-snapshot>